import styled from 'styled-components/macro';

export interface ButtonStyleProps {
  placeholderColor?: string;
  placeholderOpacity?: number;
  placeFontFamily?: string;
  placeFontSize?: number;
}

export const InputStyle = styled.input<ButtonStyleProps>`
  ::placeholder {
    color: ${({ placeholderColor }) => (placeholderColor != null ? placeholderColor : 'unset')};
    opacity: ${({ placeholderOpacity }) => (placeholderOpacity != null ? placeholderOpacity : 'unset')};
    font-family: ${({ placeFontFamily }) => (placeFontFamily != null ? placeFontFamily : 'unset')};
    font-size: ${({ placeFontSize }) => (placeFontSize != null ? placeFontSize : 'unset')};
  }
`;
